import React, {useContext, useEffect, useState} from "react";
import {
  Layout,
  Row,
  Col,
  Divider,
  List,
  Typography,
  Table,
  Tag,
  Space,
  Form,
  Checkbox,
  Button,
  Input,
  Image,
  Select,
  Modal,
} from "antd";
import { Content } from "antd/lib/layout/layout";
import "../styleCss.scss";
import checkboxSel from "../../../../assets/circle.png";
import checkboxEm from "../../../../assets/circleselect.png";
import { CloseOutlined } from "@ant-design/icons";
import apiJurados from '../../../../api/Jurados/api-jurados'
import EscudoAlcaldiaBlanco from "../../../../assets/landing/medellin.png";



import EvaluaarProyectoFormNotaModel from "./EvaluaarProyectoFormNotaModel";
/* import ViewTechnicalDocumentsProjectModel from "./ViewTechnicalDocumentsProjectModel"; */
import { ProyectoJurado } from '../../../../models/JuradosModel/jurados.model';
import EvaluarProyectoModalAnexos from "./EvaluarProyectoModalAnexos";
import { ModalVisualizarDocumentos } from "../../../../components/Generales/ModalVisualizarDocumentos";
import apiNotificaciones from "../../../../api/Notificaciones/api-notificaciones";
import {TemplateContext} from "../../../../utils/template_context";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';


const getJurado = async (data: any) => {
  const response = await apiJurados.obtenerCriterioJurado(data)
  return response;
}
export const EvaluacionProyectosModel = (props: any) => {
  const [criterios, setCriterios] = useState<any>();
  useEffect(() => {
    getJurado(props.jurado.id_jurado)
      .then(resp => {
        setCriterios(resp)
      })

  }, [props.jurado.id_jurado])

  const [tableShow, setTableShow] = useState<any>("documentosTecnicos");
  const [evalProyectoPage, setEvalProyectoPage] = useState<any>("informacionProyectosList");
  // const [isTerm, setTerm] = useState<any>(false);
  const [documentOpen, setDocumentOpen] = useState<any>(false);
  const [modalAnnexes, setModalAnnexes] = useState(false)
  const [modalVisualizarDocumento, setModalVisualizarDocumento] = useState(false);
  const [documentoVisualizar, setDocumentoVisualizar] = useState("")
  const context = useContext(TemplateContext);

  const columns: any = [
    {
      title: <span className="as_tbl_hd">Nombre documento</span>,
      width: 500,
      dataIndex: "tipo_documento",
      key: "tipo_documento",
      fixed: context.device === "md"? "left": false,
      // render: () => <span></span>
    },
    {
      title: <span className="as_tbl_hd">Acciones</span>,
      key: "acciones",
      fixed: context.device === "lg"? "right": false,
      width: 70,
      render: (datos: any) => (
        <a className="view_detl"
          onClick={() => {
            setModalVisualizarDocumento(true);
            setDocumentoVisualizar(datos.url_participante)
          }}>
          Ver Mas
        </a>
      ),
    },
  ];

  const enlacesdivumns: any = [
    {
      render: (datos: any) => (
        <span>
          <a href={datos.url} target="_blank">{datos.url}</a>
        </span>
      )
    },
  ];

  const numerosEnPalabras: string[] = [
    'Cero', 'Uno', 'Dos', 'Tres', 'Cuatro', 'Cinco', 'Seis', 'Siete', 'Ocho', 'Nueve',
    'Diez', 'Once', 'Doce', 'Trece', 'Catorce', 'Quince', 'Dieciséis', 'Diecisiete', 'Dieciocho', 'Diecinueve',
    'Veinte', 'Veintiuno', 'Veintidós', 'Veintitrés', 'Veinticuatro', 'Veinticinco', 'Veintiséis', 'Veintisiete', 'Veintiocho', 'Veintinueve',
    'Treinta', 'Treinta y uno', 'Treinta y dos', 'Treinta y tres', 'Treinta y cuatro', 'Treinta y cinco', 'Treinta y seis', 'Treinta y siete', 'Treinta y ocho', 'Treinta y nueve',
    'Cuarenta', 'Cuarenta y uno', 'Cuarenta y dos', 'Cuarenta y tres', 'Cuarenta y cuatro', 'Cuarenta y cinco', 'Cuarenta y seis', 'Cuarenta y siete', 'Cuarenta y ocho', 'Cuarenta y nueve',
    'Cincuenta', 'Cincuenta y uno', 'Cincuenta y dos', 'Cincuenta y tres', 'Cincuenta y cuatro', 'Cincuenta y cinco', 'Cincuenta y seis', 'Cincuenta y siete', 'Cincuenta y ocho', 'Cincuenta y nueve',
    'Sesenta', 'Sesenta y uno', 'Sesenta y dos', 'Sesenta y tres', 'Sesenta y cuatro', 'Sesenta y cinco', 'Sesenta y seis', 'Sesenta y siete', 'Sesenta y ocho', 'Sesenta y nueve',
    'Setenta', 'Setenta y uno', 'Setenta y dos', 'Setenta y tres', 'Setenta y cuatro', 'Setenta y cinco', 'Setenta y seis', 'Setenta y siete', 'Setenta y ocho', 'Setenta y nueve',
    'Ochenta', 'Ochenta y uno', 'Ochenta y dos', 'Ochenta y tres', 'Ochenta y cuatro', 'Ochenta y cinco', 'Ochenta y seis', 'Ochenta y siete', 'Ochenta y ocho', 'Ochenta y nueve',
    'Noventa', 'Noventa y uno', 'Noventa y dos', 'Noventa y tres', 'Noventa y cuatro', 'Noventa y cinco', 'Noventa y seis', 'Noventa y siete', 'Noventa y ocho', 'Noventa y nueve','Cien'
  ];

  const obtenerLetras = (num: number) => {
    if (num >= 0 && num <= 100) {
      return numerosEnPalabras[num];
    } else {
      return 'Sin dato';
    }
  }

  const imprimir = () => {
    const modalContent = document.getElementById('modal_custom')
    if (modalContent) {
      html2canvas(modalContent).then(canvas => {
        const imgData = canvas.toDataURL('image/png') // Convierte el canvas a datos de imagen
        const pdf = new jsPDF('p', 'mm', 'a4');
        pdf.addImage(imgData, 'PNG', 0, 0, 210, 297) // Agrega la imagen al documento PDF (tamaño A4)
        pdf.save('Evaluación de Proyecto.pdf') // Descarga el documento como 'documento.pdf'
      })
    }
  }

  const enlacesColumns: any = [
    {
      title: <span className="as_tbl_hd">No.</span>,
      width: 40,
      dataIndex: "no",
      key: "no",
      fixed: context.device === "md"? "left": false,
      render: (datos: any, record: any, index: any) => <span>{index + 1}</span>
    },
    {
      title: <span className="as_tbl_hd">Nombre documento</span>,
      width: 600,
      dataIndex: "url",
      key: "url",
       fixed: context.device === "md"? "left": false,
    },
    // {
    //   title: <span className="as_tbl_hd">Acciones</span>,
    //   key: "acciones",
    //   // fixed: context.device === "lg"? "right": false,
    //   width: 100,
    //   render: () => <a></a>,
    // },
  ];

  useEffect(() => {
    // setEvalProyectoPage(props.evalProyectoPage);
  }, [evalProyectoPage]);

  return (
    <div id="modal_custom">
      {documentOpen ? (
        <Layout style={{ borderRadius: 15 }}>
        </Layout>
      ) : (
        <div>
          {evalProyectoPage === "informacionProyectosList" ? (
            <div>
              <div className="container-fluid" style={{ background: "white", borderRadius: "15px" }}>
                <Content className="model__header">
                  <Content className="mdl_header_containt">
                    <div className="mdl_heading_row">
                      <div className="col-12">
                        <div className="evel_mdl_title font-size-14px pt-2 pb-2 title_modal_morado">
                          Evaluación de Proyecto
                        </div>
                      </div>
                    </div>
                  </Content>
                </Content>
                <Content className="row evalu__top_mdl_box">
                  <Content
                    className="col-12 evalu_inform_header"
                    style={{ background: "#AE3E97" }}
                  >
                    <ul
                      className="menu_tab"
                      style={{ listStyle: "none", display: "flex", margin: "unset" }}
                    >
                      <li
                        className={evalProyectoPage == "informacionProyectosList" ? "active2" : ""}
                      >
                        <a
                          onClick={() => setEvalProyectoPage("informacionProyectosList")}
                        >
                          Información del proyecto
                        </a>
                      </li>
                      {props.proyectosJurado.proyecto.estado == 'Por evaluar' &&
                        <li
                            className={evalProyectoPage == "evaluaarProyectoForm" ? "active2" : ""}
                        >
                          <a
                            onClick={() => setEvalProyectoPage("evaluaarProyectoForm")}
                          >
                            Evaluar proyecto
                          </a>
                        </li>
                      }
                    </ul>
                  </Content>

                  <Content
                    className="col-12 evalu_inform_list mb-2"
                    style={{ marginTop: 15, padding: "5px 20px 20px 20px" }}
                  >
                    <div className="row">
                      <Image src={EscudoAlcaldiaBlanco} style={{ maxWidth: "20%"}} preview={false} />
                      <br />
                      <br />
                      <span className="md-title-text text-center">
                        <br />
                        SECRETARÍA DE CULTURA CIUDADANA
                      </span>
                      <br />
                      <span className="md-title-text text-center">
                        CONVOCATORIA DE FOMENTO Y ESTÍMULOS PARA EL ARTE Y LA CULTURA
                      </span>
                    </div>
                    <br />
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <div className="row">
                          <div className="col-12 col-md-6 col-lg-4 text-right inform--col">
                            <Content className="inform--col-box d-flex justify-content-md-end">
                              {" "}
                              <span className="inform_title">Código del proyecto:</span>
                            </Content>
                            <hr />
                          </div>
                          <div className="col-12 col-md-6 col-lg-8 inform--col">
                            <Content className="inform--col-box">
                              {" "}
                              <span className="inform_value font-family-Montserrat-Regular" style={{fontWeight: 'bold' }}>{props.proyectosJurado.proyecto.radicado} </span>
                            </Content>
                            <hr />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="row">
                          <div className="col-12 col-md-6 col-lg-4 text-right inform--col">
                            <Content className="inform--col-box d-flex justify-content-md-end">
                              {" "}
                              <span className="inform_title">Línea:</span>
                            </Content>
                            <hr />
                          </div>
                          <div className="col-12 col-md-6 col-lg-8 inform--col">
                            <Content className="inform--col-box">
                              {" "}
                              <span className="inform_value font-family-Montserrat-Regular" style={{fontWeight: 'bold' }}>
                                {props.proyectosJurado?.proyecto.linea_convocatoria}
                              </span>
                            </Content>
                            <hr />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="row">
                          <div className="col-12 col-md-6 col-lg-4 text-right inform--col">
                            <Content className="inform--col-box d-flex justify-content-md-end">
                              {" "}
                              <span className="inform_title">Nombre del proyecto:</span>
                            </Content>
                            <hr />
                          </div>
                          <div  className="col-12 col-md-6 col-lg-8 inform--col">
                            <Content className="inform--col-box">
                              {" "}
                              <span className="inform_value font-family-Montserrat-Regular" style={{fontWeight: 'bold' }}>{props.proyectosJurado.proyecto.nombre_propuesta}</span>
                            </Content>
                            <hr />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="row">
                          <div className="col-12 col-md-6 col-lg-4 text-right inform--col">
                            <Content className="inform--col-box d-flex justify-content-md-end">
                              {" "}
                              <span className="inform_title">Categorías:</span>
                            </Content>
                            <hr />
                          </div>
                          <div className="col-12 col-md-6 col-lg-8 inform--col">
                            <Content className="inform--col-box font-family-Montserrat-Regular" style={{fontWeight: 'bold' }}>
                              {" "}
                              {props.proyectosJurado.proyecto.categoria_linea_convocatoria}
                            </Content>
                            <hr />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Content>
                </Content>
              </div>

              <div className="container-fluid" style={{ marginTop: "10px", background: "white", padding: 20, borderRadius: "15px" }}>
                <Content className="category_mdl_box">
                  <Content className="category_head">
                    <span className="col-12 md-title-text">
                      Criterios de evaluación
                    </span>
                  </Content>
                  <Content className="cat_listing">
                    <hr />
                    <List
                      style={{ paddingTop: "5px", paddingBottom: "5px", }}
                      itemLayout="horizontal"
                      dataSource={props.proyectosJurado.criterios}
                      footer={
                        <div>
                          <List.Item style={{ background: '#faad1424' }}>
                            <List.Item.Meta
                              className="list_cat"
                              title={<span className="cat_list_title font-family-Montserrat-Regular" style={{ padding:"10px"}}>Puntaje total:</span>}
                              description={<span className="cat_list_title font-family-Montserrat-Regular" style={{ padding:"10px"}}>Puntaje total en letras: <span style={{ fontWeight: 'bold'}}>{obtenerLetras(props.proyectosJurado.proyecto.nota_final)}</span></span>}
                            />
                            <div style={{ padding:"10px", fontWeight: 'bold', color: "orange" }}>{props.proyectosJurado.proyecto.nota_final}</div>
                        </List.Item>
                        </div>
                    }
                      renderItem={(item: any, index: number) => (
                        <List.Item style={{ background: index % 2 === 0 ? '#f0f0f0' : 'white' }}>
                          <List.Item.Meta
                            className="list_cat"
                            title={<span className="cat_list_title font-family-Montserrat-Regular">{item.nombre}</span>}
                            description={<span className="cat_list_title font-family-Montserrat-Regular" style={{fontWeight: 'bold'}}>{item.observaciones}</span>}
                          />
                           <div style={{ padding:"10px", fontWeight: 'bold' }}>{item.nota}</div>
                        </List.Item>
                      )}
                    />
                  </Content>
                </Content>
              </div>

              <div style={{ marginTop: "10px", background: "white", borderRadius: "15px" }}>
                <Content className="evalu_mdl_box" style={{ borderRadius: "15px" }}>
                  <Content
                    className="evalu_head"
                    style={{
                      background: "#AE3E97",
                      display: "flex",
                      width: "100%",
                      borderTopLeftRadius: "15px",
                      borderTopRightRadius: "15px",
                    }}
                  >
                    <Content
                      className="evalu_inform_header"
                      style={{ background: "#AE3E97", display: "flex", width: "100%", borderRadius: '15px' }}
                    >
                      <ul
                        className="evalu_inform_menu evalu_info"
                        style={{
                          listStyle: "none",
                          background: "#AE3E97",
                          display: "flex",
                          alignItems: "center",
                          margin: "unset",
                          borderRadius: '15px',
                        }}
                      >
                        <li
                          className={tableShow === "documentosTecnicos" ? "enabled_tab" : "disabled_tab"}
                        >
                          <a
                            onClick={() => setTableShow("documentosTecnicos")}
                          >
                            Documentos técnicos del proyecto
                          </a>
                        </li>
                        <li
                          className={tableShow === "enlacesProyecto" ? "enabled_tab" : "disabled_tab"}
                        >
                          <a
                            onClick={() => setTableShow("enlacesProyecto")}
                          >
                            Enlaces del proyecto
                          </a>
                        </li>
                      </ul>
                    </Content>
                  </Content>
                  <Content className="evalu_listing" style={{ padding: "5px 20px" }}>
                    {tableShow === "documentosTecnicos" ? (
                      <Table
                        columns={columns}
                        dataSource={props.proyectosJurado.proyecto.documentos_tecnicos}
                        scroll={{ x: 900 }}
                        pagination={false}
                        rowClassName={(record, index) => (index % 2 === 0 ? "table-row-dark" : "table-row-light")}
                      />
                    ) : (
                      <Table
                        columns={enlacesdivumns}
                        dataSource={props.proyectosJurado.proyecto.links}
                        scroll={{ x: 1000 }}
                        pagination={false}
                        rowClassName={(record, index) => (index % 2 === 0 ? "table-row-dark" : "table-row-light")}
                      />
                    )}
                  </Content>
                  {props.proyectosJurado.proyecto.nota_final == null &&
                    <Content className="container-fluid">
                      <Content
                        style={{
                          height: "20px",
                          display: "flex",
                          justifyContent: "end",
                          marginTop: "10px",
                          marginBottom: "20px",
                        }}
                      >
                        {/* <Image
                          onClick={() => props.setIsTerm(!props.isTerm)}
                          width={29}
                          height={15}
                          style={{ margin: 6 }}
                          preview={false}
                          src={!props.isTerm ? checkboxSel : checkboxEm}
                        />
                        <span className="cat_mdl_chk" style={{ marginRight: "1rem" }}>
                          Me declaro inhabilitado para evaluar este proyecto{" "}
                        </span> */}
                      </Content>
                    </Content>
                  }
                  <hr className="m-0" />
                </Content>

                <Content className="mb-2" style={{ padding: 20 }}>
                  <div className="container-fluid">
                    <div className="form--btm-btn-box d-flex justify-content-center">
                      <Button className="form_bg_btn button-blanco-radius m-0"
                        onClick={imprimir} style={{ border: "none" }}>
                        IMPRIMIR
                      </Button>
                    </div>
                    <div className="form--btm-btn-box d-flex justify-content-end">
                      {props.isTerm &&
                        <Button
                          onClick={async () => {
                            try {
                              let payloadNotificacionAdmin = {
                                nombre_jurado: `${props.jurado.primer_nombre} ${props.jurado.segundo_nombre} ${props.jurado.primer_apellido} ${props.jurado.segundo_apellido}`,
                                tipo_notificacion: "Inhabilita",
                                remitente: props.jurado.numero_documento,
                              }

                              await apiNotificaciones.enviarNotificacionAdministrador(payloadNotificacionAdmin);

                              await apiJurados.desahabilitarProject(props.jurado.id_jurado, props.proyectosJurado.proyecto.id_postulacion);
                              props.setVisible(false);
                              props.consultarProyectoJuradoCriterioProyecto();
                            } catch (error) {
                              console.log(error)
                            }

                          }}
                          className="form_bg_btn font-family-Montserrat-SemiBold"
                          type="primary"
                        >
                          INHABILITAR PROYECTO
                        </Button>
                      }
                      <Button className="form_bg_btn button-blanco-radius m-0"
                        onClick={() => {
                          props.setVisible(false);
                          props.setIsTerm(false)
                        }} style={{ border: "none" }}>
                        CERRAR
                      </Button>
                    </div>
                  </div>
                </Content>
              </div>
            </div>
          ) : evalProyectoPage === "evaluaarProyectoForm" ? (
            <EvaluaarProyectoFormNotaModel
              evalProyectoPage={evalProyectoPage}
              setEvalProyectoPage={setEvalProyectoPage}
              jurado={props.proyectosJurado}
              isTerm={props.isTerm}
              setVisible={props.setVisible}
              consultarProyectoJuradoCriterioProyecto={props.consultarProyectoJuradoCriterioProyecto}

            />
          ) : (
            ""
          )}

          {modalVisualizarDocumento &&
            <ModalVisualizarDocumentos
              visualizar={modalVisualizarDocumento}
              setVisualizar={setModalVisualizarDocumento}
              state={{ documento: documentoVisualizar }}
            />}
          {/* {evalProyectoPage === 'modalAnexo' ? (
            <EvaluarProyectoModalAnexos
              evalProyectoPage={evalProyectoPage}
              setVisible={props.setVisible}
              setEvalProyectoPage={setEvalProyectoPage}
              jurado={props.proyectosJurado}
            />
          ) : (
            ""
          )} */}
        </div>
      )}
    </div>
  );
};
